import type {DomainsBaseStyles} from '../../types'
import {defaultStyles} from '../default-styles'

export const ozzieChoiceReviewsStylesAU: DomainsBaseStyles = {
  ...defaultStyles,
  COMMONS_BODY: 'bg-white',
  COMMONS_APPBAR_BG: 'bg-blue-50',
  COMMONS_APPBAR_TEXT: 'text-black',
  COMMONS_APPBAR_SIDE_MENU_CLOSE_ICON: 'fill-black',
  COMMONS_APPBAR_MENU_BURGER: '[&>.burger-line]:stroke-black',

  COMMONS_FOOTER_BG: 'bg-blue-50',
  COMMONS_FOOTER_TEXT: 'text-black',

  COMMONS_WIDGETS_SEARCH_ICON: '[&>g>path]:fill-black',
  COMMONS_WIDGETS_SEARCH_SUBMIT: 'bg-red-600 [&>svg>path]:stroke-white',
  COMMONS_WIDGETS_SEARCH_SHADOW: 'shadow-xl',

  HOMEPAGE_HEADER_BG: 'bg-[#F9FAFB]',
  HOMEPAGE_HEADER_TEXT: 'text-black',
  HOMEPAGE_HEADER_TITLE_DOT: 'after:text-[#1E3A8A]',
  HOMEPAGE_HEADER_ICON_FILL: 'fill-black',
  HOMEPAGE_HEADER_ICON_STROKE: '[&>path]:stroke-black',
  HOMEPAGE_HEADER_TITLE_STAR: 'before:text-red-500',
  HOMEPAGE_TOPRATED_BUTTON: 'border-[#f0c52b] hover:border-[#f0c52b] hover:bg-[#f0c52b] text-black',
  HOMEPAGE_CONTENT_DIVIDER: 'bg-[#f0c52b]',

  HOMEPAGE_RANK_BANNER_BG: 'bg-blue-50',
  HOMEPAGE_RANK_BANNER_TEXT: 'text-black',
  HOMEPAGE_CATEGORIES_CARD_BORDER: 'border-blue-50',
  HOMEPAGE_TOP_DISCOUNTED_BG: 'bg-red-500',
  HOMEPAGE_BUTTON_PRIMARY:
    'bg-[#1E3A8A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_SECONDARY:
    'border-[#1E3A8A] text-[#1E3A8A] [&>svg>path]:stroke-[#1E3A8A] [&>svg>g>path]:stroke-[#1E3A8A] [&>svg>path]:fill-[#1E3A8A] [&>svg>g>path]:fill-[#1E3A8A]',
  HOMEPAGE_BUTTON_ARROW_BG: 'bg-[#1E3A8A]',
  HOMEPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  HOMEPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  HOMEPAGE_DID_YOU_KNOW_CTA: 'bg-blue-50',
  HOMEPAGE_DID_YOU_KNOW_BG: 'bg-[#F9FAFB]',
  HOMEPAGE_DID_YOU_KNOW_TEXT: 'text-black',
  HOMEPAGE_ON_SALE_CTA: 'bg-red-500',
  HOMEPAGE_EXPLORE_BANNER_BG: 'bg-[#F9FAFB]',
  HOMEPAGE_EXPLORE_BANNER_TEXT: 'text-black',
  HOMEPAGE_EXPLORE_BANNER_TEXT_STAR: 'before:text-black',
  HOMEPAGE_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-blue-50 [&>.explore-icon-fill]:!fill-[#F9FAFB] [&>g>.explore-icon-fill]:!fill-[#F9FAFB]',
  HOMEPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#F9FAFB] [&>.vector-top>path]:fill-blue-50 [&>.vector-bottom>path]:fill-blue-50',

  LISTPAGE_HERO_IMAGE_HEADER_TEXT: 'text-white',

  LISTPAGE_USER_VALUE_BADGE: 'text-[#1E3A8A] [&>div>svg>path]:fill-[#1E3A8A] bg-[#FFF9E9]',

  LISTPAGE_BADGE_PLACEMENT_BG: 'bg-[#FFF9E9]',
  LISTPAGE_BADGE_PLACEMENT_TEXT: 'text-[#1E3A8A]',

  LISTPAGE_BADGE_SPONSORED_BG: 'bg-blue-50',
  LISTPAGE_BADGE_SPONSORED_TEXT: 'text-[#1F2937]',

  LISTPAGE_BADGE_WINNER_BG: 'bg-[#FFF9E9]',
  LISTPAGE_BADGE_WINNER_TEXT: 'text-[#1E3A8A]',
  LISTPAGE_BADGE_WINNER_DIVIDER: '!divide-[#1E3A8A]',

  LISTPAGE_BADGE_BEST_VALUE_BG: 'bg-[#FFF9E9]',
  LISTPAGE_BADGE_BEST_VALUE_TEXT: 'text-[#1E3A8A]',
  LISTPAGE_BADGE_BEST_VALUE_DIVIDER: '!divide-[#1E3A8A]',

  LISTPAGE_BADGE_CARD_DISCOUNT_BG: 'bg-red-500',
  LISTPAGE_BADGE_CARD_DISCOUNT_TEXT: 'text-white',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_BG: 'bg-[#1F2937]',
  LISTPAGE_BADGE_CARD_DISCOUNT_OLD_TEXT: '!text-white',

  LISTPAGE_BADGE_CTA_DISCOUNT_BG: 'bg-blue-50',
  LISTPAGE_BADGE_CTA_DISCOUNT_TEXT: 'text-black',

  LISTPAGE_BADGE_EDITORS_CHOICE_TEXT: 'text-[#2C0065]',
  LISTPAGE_BADGE_EDITORS_CHOICE_ICON_STROKE: 'stroke-[#2C0065]',

  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_BG: 'bg-blue-50',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_TEXT: 'text-black',
  LISTPAGE_BADGE_CTA_MARKETPLACE_LOGO_ICON: '[&>svg>g>g>g>.fill-current]:!fill-black',

  LISTPAGE_BADGE_SCORE_TEXT: 'text-[#1F2937]',

  LISTPAGE_BUTTON_PRIMARY:
    'bg-[#1E3A8A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_SECONDARY:
    'border-[#1E3A8A] text-[#1E3A8A] [&>svg>path]:stroke-[#1E3A8A] [&>svg>g>path]:stroke-[#1E3A8A] [&>svg>path]:fill-[#1E3A8A] [&>svg>g>path]:fill-[#1E3A8A]',
  LISTPAGE_BUTTON_LINK: 'text-[#1E3A8A]',
  LISTPAGE_ANCHOR_LINK: 'text-[#1E3A8A]',
  LISTPAGE_BUTTON_ARROW_BG: 'bg-[#1E3A8A]',
  LISTPAGE_BUTTON_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_ICON_FILL: 'fill-[#1E3A8A]',
  LISTPAGE_BUTTON_ICON_STROKE: 'stroke-[#1E3A8A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_PRIMARY:
    'bg-[#1E3A8A] text-white [&>svg>path]:stroke-white [&>svg>g>path]:stroke-white [&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_SECONDARY:
    'border-[#1E3A8A] text-[#1E3A8A]  [&>svg>path]:stroke-[#1E3A8A] [&>svg>g>path]:stroke-[#1E3A8A] [&>svg>path]:fill-[#1E3A8A] [&>svg>g>path]:fill-[#1E3A8A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_LINK: 'text-[#1E3A8A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_BG: 'bg-[#1E3A8A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_FILL: '[&>svg>path]:fill-white [&>svg>g>path]:fill-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ARROW_ICON_STROKE: '[&>svg>path]:stroke-white [&>svg>g>path]:stroke-white',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_FILL: 'fill-[#1E3A8A]',
  LISTPAGE_BUTTON_NEW_LAYOUT_ICON_STROKE: 'stroke-[#1E3A8A]',

  LISTPAGE_SPONSORED_CARD_BORDER: 'tablet:border-[#1E3A8A]',

  LISTPAGE_TOP_PICKS_SPECS_CARD_BORDER: 'tablet:border tablet:border-gray-400',

  LISTPAGE_WIDGETS_QUICK_NAVIGATION_TEXT: 'text-black',
  LISTPAGE_WIDGETS_QUICK_NAVIGATION_BORDER: 'border-[#1E3A8A]',

  LISTPAGE_WIDGETS_RECOMMENDED_PRODUCTS:
    'bg-[#FFFBEB] [&>.vector-top>path]:fill-blue-50 [&>.vector-bottom>path]:fill-blue-50',

  LISTPAGE_WIDGETS_RELATED_PRODUCTS_BG: 'bg-neutral-100',

  LISTPAGE_WIDGETS_SPECS_CHECKED_ICON: '[&>circle]:fill-[#E5E7EB] [&>circle]:stroke-[#E5E7EB] [&>path]:fill-black',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_BG: 'bg-blue-50',
  LISTPAGE_WIDGETS_SPECS_ACCORDION_BUTTON_ICON: '[&>svg]:fill-[#1E3A8A]',

  LISTPAGE_WIDGETS_SORT_BY_BUTTON: 'bg-[#F4F4F5]',

  LISTPAGE_WIDGETS_SORT_BY_OPTION: 'data-[focus]:bg-blue-50 data-[focus]:text-[#1E3A8A]',
  LISTPAGE_WIDGETS_SORT_BY_SELECTED_OPTION: 'bg-blue-50',
  LISTPAGE_WIDGETS_SORT_BY_CURRENT_OPTION_LABEL: 'font-medium text-[#1E3A8A]',
  LISTPAGE_WIDGETS_AFFILIATEDISCLOSURE_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_SHAREMENU_BUTTON: 'bg-[#F4F4F5]',
  LISTPAGE_WIDGETS_DISCLAIMER_INFO_BUTTON: 'bg-[#F4F4F5]',

  LISTPAGE_SECTIONS_EXPLORE_BANNER_BG: 'bg-amber-200',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_TEXT: 'text-black',
  LISTPAGE_SECTIONS_EXPLORE_BANNER_ICONS:
    '[&>.explore-icon-bg]:!fill-[#FBBF24] [&>.explore-icon-fill]:!fill-[#92400E] [&>g>.explore-icon-fill]:!fill-[#92400E]',

  UTILS_MAIN_CONTAINER: 'content-container',
}
